<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendPackage',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.package_name }}</span>
    </div>
    <div class="bread" v-else>
      <router-link :to="{ path: nav.url }">{{ nav.name }}</router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.package_name }}</span>
    </div>
    <template v-if="detail.status == 1">
      <div class="package-cover-wrap">
        <ImageClip
          class="cover f-left"
          :src="detail.cover_img"
          :width="420"
          :height="279"
          :radius="5"
        ></ImageClip>
        <div class="right f-left" style="display: flex;flex-direction: column;justify-content: space-between;padding-bottom: 31px;">
          <div class="title">{{ detail.package_name }}</div>
          <div class="market">{{ detail.marketing_language }}</div>
          <div class="count-wrap" v-if="detail.course_total>0">
            <div class="count">
              <img
                class="count-img"
                src="@/assets/images/package/count@2x.png"
              />
              <span class="count-text">
                包含{{ detail.course_total }}门课程
              </span>
            </div>
          </div>
          <div
            class="service-wrap"
            v-if="detail.course_service && detail.course_service.length > 0"
          >
            <span class="label">课程服务：</span>
            <div class="container clearfix">
              <div ref="services" class="services">
                <span
                  class="service"
                  v-for="service in detail.course_service"
                  :key="service.name"
                >
                  <i class="el-icon-circle-check"></i>
                  <span>{{ service.name }}</span>
                </span>
              </div>
              <div class="more" v-if="hasServiceMore">详情 ></div>
            </div>
            <div class="service-popper" v-if="hasServiceMore">
              <span
                class="service"
                v-for="service in detail.course_service"
                :key="service.name"
              >
                <i class="el-icon-circle-check"></i>
                <span>{{ service.name }}</span>
              </span>
            </div>
          </div>
          <div class="price-container">
            <div class="price price-zero" v-if="detail.price == 0">免费</div>
            <CurrencyNew
              v-else
              :price="detail.price"
              :priceUnderline="
                detail.sale_money == detail.price ? 0 : detail.sale_money
              "
              :isUnderlineLeft="false"
              priceTwo
            ></CurrencyNew>
            <div class="discount" v-if="detail.course_total>0">
              {{ detail.course_total }}门课程一起报名立省{{
                (detail.sale_money - detail.price) / 100
              }}元
            </div>
          </div>
          <div class="package-detail-footer">
            <a class="btn btn-soldout" v-if="hasApply">已报名</a>
            <a @click="goToBuy" class="btn" v-else-if="detail.stock > 0">
              立即报名
            </a>
            <a class="btn btn-soldout" v-else>已售罄</a>
            <span class="package-detail-sales">
              {{ detail.sales_num }}人已报名
            </span>
          </div>
        </div>
      </div>
      <div class="package-detail-tabs" v-if="courses.length>0">
        <BlockTabs :items="courseTabs" currentClass="bold5" isNew></BlockTabs>
        <div class="package-detail-free">已报名课程无需重复付费，赠品不可单独退款</div>
        <div class="package-detail-courses">
          <PackageCourse
            v-for="course in courses"
            :is_small_course_open="detail.is_small_course_open"
            :key="course.id"
            :course="course"
          ></PackageCourse>
        </div>
        <div
          v-if="
            showMore &&
            detail.package_course_items &&
            detail.package_course_items.length > courseDefaultCount
          "
          class="package-detail-more"
          @click="showMore = false"
        >
          <span class="package-detail-more_span">查看全部</span>
        </div>
      </div>
            <CourseShowTeacher :teachers="teachers" v-if="teachers.length>0"  ></CourseShowTeacher>
      <div class="package-detail-tabs">
        <BlockTabs :items="tabs" currentClass="bold5" isNew></BlockTabs>
        <div
          class="tab-content-detail"
          v-html="detail.detail"
          oncontextmenu="return false"
          onselectstart="return false"
        ></div>
        <div v-if="detail.detail == ''" class="empty">
          <img src="@/assets/images/homework/empty.png" />
          <div class="text">暂无数据</div>
        </div>
      </div>
    </template>
    <CourseSoldOut
      v-if="detail.status == 2 || detail.status == 3"
      router-name="Package"
      name="课程包"
    ></CourseSoldOut>
  </div>
</template>
<script>
import PackageCourse from "./components/PackageCourse.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
import CourseShowTeacher from "../../components/rich/CourseShowTeacher";
export default {
  name: "PackageDetail",
  components: { PackageCourse, CourseSoldOut,CourseShowTeacher },
  data() {
    return {
      id: this.$route.params.id,
      detail: {},
      isSet: false,
      showModal: false,
      hasServiceMore: false,
      courseTabs: [{ id: 1, name: "包含课程" }],
      tabs: [{ id: 1, name: "课程详情" }],
      courseDefaultCount: 6,
      showMore: true,
    };
  },
  computed: {
    navigates() {
      return this.$store.state.navigates;
    },
    nav() {
      let nav = this.navigates.filter(n => n.id == this.$route.query.nav)[0];
      if (nav && nav.url != "/index") {
        nav = { ...nav };
        let url = nav.url;
        if (url.indexOf("?") < 0) {
          url += "?";
        } else {
          url += "&";
        }
        url += "nav=" + nav.id;
        nav.url = url;
        return nav;
      }
      return { name: "课程包", url: "/package" };
    },
    courses() {
      if (!this.detail.package_course_items) {
        return [];
      }
      if (!this.showMore) {
        return this.detail.package_course_items;
      }
      return this.detail.package_course_items.slice(0, this.courseDefaultCount);
    },
    hasApply() {
      let items = this.detail.package_course_items;
      if (this.detail.packageCourseStatus == 1) {
        return true;
      }
      if (!items || items.length == 0) {
        return false;
      }
      for (let i = 0, len = items.length; i < len; i++) {
        let item = items[i];
        if (item.packageCourseStatus != 1) {
          return false;
        }
      }
      return true;
    },
    teachers(){
      console.log(45,this.detail.teacherList)
      return this.detail.teacherList.map(item=>{
        
        return {
          teacher_name:item.real_name,
          teacher_id:item.id,
          ...item
        }
      })
    }
  },
  watch: {
    detail() {
      this.$nextTick(() => {
        this.setServiceMore();
      });
    },
  },
  async created() {
    this.detail = await this.$http.get("/api/app/packageCourse/" + this.id);
    this.$nextTick(() => {
      this.setServiceMore();
    });
  },
  methods: {
    setServiceMore() {
      if (!this.$refs.services) {
        return;
      }
      if (this.$refs.services.clientHeight > 20) {
        this.hasServiceMore = true;
      } else {
        this.hasServiceMore = false;
      }
    },
    goToBuy() {
      this.$router.push({
        name: "OrderConfirm",
        query: {
          package_id: this.id,
          order_type: 8,
          // type: 7,
          shop_infos: JSON.stringify(
            this.detail.package_course_items
              .filter(course => course.packageCourseStatus == 2)
              .map(course => ({
                shop_id: course.course_id,
                shop_type: course.course_type,
              })),
          ),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/modules/stu/css/package-detail.scss";

/deep/.tab-content-detail {
  padding:20px 80px !important;
  img{
    width: 100% !important;
  }
}
</style>
